import React from 'react';
import {contentProps} from './content.props';
import {GridList, GridTile} from 'material-ui/GridList';
import IconButton from 'material-ui/IconButton';
import IconDelete from '../../Icons/IconDelete';
import Input from '../../form/Input';
import {GalleryContentItem} from '../../../api/club-cms/content/gallery.content';
import {UploadFile} from '../../form/UploadFile/UploadFile';
import style from './GalleryComponent.scss';

export class GalleryComponent extends React.Component {
  static propTypes = {
    ...contentProps
  };

  handleFileChoose(files) {
    const {node, onChange} = this.props;
    let newNode = node;

    for (var i = 0, numFiles = files.length; i < numFiles; i++) {
      var file = files[i];
      newNode = newNode.push(new GalleryContentItem(file));
    }

    onChange(newNode);
  }

  deleteItem(item) {
    const {node, onChange} = this.props;
    onChange(node.remove(item));
  }

  render() {
    const {node, onChange} = this.props;

    return (<div>
      <Input label="Add Gallery Name"
             required={true}
             value={node.label}
             style={{marginBottom: 10}}
             onChange={(value) => onChange(node.updateLabel(value))}/>
      <GridList cols={3}
                padding={16}
                cellHeight={123}>
        {node.items.map((image, key) => (<GridTile key={key}>
          <div className={style.galleryItem}>
            <div className={style.galleryImage} style={{backgroundImage: `url(${image})`}}/>

            <div className={style.actionButtonContainer}>
              <IconButton onClick={(event) => {
                            event.stopPropagation();
                            event.preventDefault();
                            this.deleteItem(image)
                          }}><IconDelete color="white"/></IconButton>
            </div>
          </div>

        </GridTile>))}
        <GridTile>
          <UploadFile label="Upload Pictures"
                      accept='image/*'
                      multiple={true}
                      onChange={(files) => this.handleFileChoose(files)}/>
        </GridTile>
      </GridList>
    </div>);
  }
}

export default GalleryComponent;



// WEBPACK FOOTER //
// ./src/components/ClubCMS/Content/GalleryComponent.js